module.exports = __webpack_public_path__ + "img/kuang1.92a56b03.png";